// Scent-quiz pop-up: opens 3 seconds after the WELCOME10 pop-up is closed (whether the
// visitor signed up or not). If the WELCOME10 pop-up is not shown this visit (already seen
// or subscribed), it opens after data-fallback-delay instead. Shown once, then remembered
// for 14 days; taking the quiz hides it for good.
const STORAGE_KEY = 'ps-quiz-popup';
const DISMISS_DAYS = 14;

class SQuizPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;
    if (this.hasSeen() && !new URLSearchParams(window.location.search).has('popups')) return;
    let embedded = false;
    try { embedded = window.self !== window.top; } catch { embedded = true; }
    if (window.Shopify?.designMode || embedded) return;

    this.onClosed = () => this.schedule(Number(this.dataset.delay) || 3000);
    this.onSkipped = () => this.schedule(Number(this.dataset.fallbackDelay) || 8000);
    document.addEventListener('ps:signup-popup-closed', this.onClosed);
    document.addEventListener('ps:signup-popup-skipped', this.onSkipped);
    if (window.psSignupPopup === 'closed') this.onClosed();
    else if (window.psSignupPopup === 'skipped' || !document.querySelector('s-signup-popup')) this.onSkipped();

    this.dialog.addEventListener('close', () => this.remember('dismissed'));
    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.dialog.close();
    });
    this.querySelector('[data-quiz-popup-cta]')?.addEventListener('click', (event) => {
      this.remember('taken');
      this.dialog.close();
      // On the homepage the button points at the full-screen quiz dialog: open it instead of following the link.
      const id = (event.currentTarget.getAttribute('href') || '').replace(/^#/, '');
      const target = id ? document.getElementById(id) : null;
      if (target instanceof HTMLDialogElement) {
        event.preventDefault();
        target.showModal();
      }
    });
  }

  disconnectedCallback() {
    clearTimeout(this.timer);
    document.removeEventListener('ps:signup-popup-closed', this.onClosed);
    document.removeEventListener('ps:signup-popup-skipped', this.onSkipped);
  }

  schedule(delay) {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.open(), delay);
  }

  open() {
    if (this.dialog.open || document.querySelector('dialog[open]')) return this.schedule(3000);
    this.dialog.showModal();
  }

  hasSeen() {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (!saved) return false;
      if (saved.state === 'taken') return true;
      return Date.now() - saved.time < DISMISS_DAYS * 86400000;
    } catch {
      return false;
    }
  }

  remember(state) {
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
      if (saved?.state === 'taken') return;
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ state, time: Date.now() }));
    } catch {
      // Storage unavailable; the pop-up may show again next visit.
    }
  }
}

if (!customElements.get('s-quiz-popup')) customElements.define('s-quiz-popup', SQuizPopup);
